var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0002 0H3.99979C1.79053 0 0 1.79053 0 3.99979V32.0002C0 34.2095 1.79053 36 3.99979 36H32.0002C34.2095 36 36 34.2095 36 32.0002V3.99979C36 1.79053 34.2095 0 32.0002 0ZM10.8853 30.9998H5.51747V13.6667H10.8853V30.9998ZM8.17389 11.3968C6.41937 11.3968 4.99832 9.96442 4.99832 8.19853C4.99832 6.43263 6.41937 5.00021 8.17389 5.00021C9.92842 5.00021 11.3476 6.43263 11.3476 8.19853C11.3476 9.96442 9.92653 11.3968 8.17389 11.3968ZM30.9998 30.9998H25.6585V21.9013C25.6585 19.4059 24.7112 18.0133 22.7368 18.0133C20.5882 18.0133 19.4665 19.4646 19.4665 21.9013V30.9998H14.3185V13.6667H19.4665V16.0011C19.4665 16.0011 21.0145 13.1362 24.6922 13.1362C28.3699 13.1362 31.0017 15.3815 31.0017 20.0255V30.9998H30.9998Z",
    fill: "#08B1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.77d0c364ccba645e7c3a1a40756cfab9.svg";
export { ForwardRef as ReactComponent };